import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { AuthShell } from "@/components/auth/auth-shell";
import { BrandPanel } from "@/components/auth/brand-panel";
import { FormPanel } from "@/components/auth/form-panel";
import { FormPanelHeader } from "@/components/auth/form-panel-header";
import { FormHeading } from "@/components/auth/form-heading";
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";

export const Route = createFileRoute("/_auth/reset-password")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const t = useTranslations();

  return (
    <AuthShell>
      <BrandPanel page="reset" />
      <FormPanel>
        <FormPanelHeader
          linkOpposite={{
            href: "/signin",
            prompt: "",
            cta: t("auth.reset.back_to_signin"),
            isBack: true,
          }}
        />
        <FormHeading
          title={t("auth.reset.title")}
          description={t("auth.reset.desc")}
        />
        <ResetPasswordForm />
      </FormPanel>
    </AuthShell>
  );
}
